(function($, window){

    // On document ready
    $(function(){   
    });

    // Immediately
    // document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");

    $('.article-hero .share').on('click', function(e){
        $(this).toggleClass('open');
    });

    let notice = $('<div class="rc-notice">This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.</div>');

    $('a[href="#recaptcha"]').on('click', e => {
        e.preventDefault();
        if (notice.parent().length) {
            notice.detach();
        }
        else {
            $(e.currentTarget).parent().append(notice);
        }
    });

    $('ul.subnav a').on('click', e => {
        e.preventDefault();
        let targetID = $(e.currentTarget).attr('href');
        if ($(targetID).length) {
            history.pushState({}, '', targetID);
            gsap.to(window, {
                duration: 0.5, 
                scrollTo: {
                    y: targetID, 
                    offsetY: 50
                },
                ease: "power3.out"
            });
        }
    });

    $('.wpcf7-select').change(function(){
        let dd = $(this);
        if (dd.val()) {
            dd.addClass('touched');
        }
        else {
            dd.removeClass('touched');
        }
    });

})(jQuery, window);
